import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";

/**
 * Returns the qualifications that are allowed for documents based on worker's shoppable qualifications.
 */
export function useGetWorkerLicensesAllowedForDocuments() {
  const { data: workerQualifications, isSuccess: workerQualificationsAreLoaded } =
    useWorkerQualifications();

  return {
    licenses: workerQualificationsAreLoaded
      ? workerQualifications?.map((qualification) => qualification.attributes.name)
      : [],
    isLoaded: workerQualificationsAreLoaded,
    areAllLicensesPending: false,
  };
}
